import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align", "direction", "justify", "gap", "flex", "style", "className", "as", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import cn from "classnames";
import React from "react";
import { getSpacing } from "../spacing";
import { isResponsiveProp } from "../Theme/ResponsiveProp";
import * as styles from "./styles.css";
export var Flex = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var alignProp = _ref.align,
    directionProp = _ref.direction,
    justifyProp = _ref.justify,
    gapProp = _ref.gap,
    flexProp = _ref.flex,
    styleProp = _ref.style,
    classNameProp = _ref.className,
    asProp = _ref.as,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var gap = undefined;
  var vars = {};
  if (gapProp) {
    if (isResponsiveProp(gapProp)) {
      vars[styles.flexGapVar] = getSpacing(gapProp.mobileAndAbove);
      vars[styles.flexTabletGapVar] = gapProp.tabletAndAbove != null ? getSpacing(gapProp.tabletAndAbove) : undefined;
      vars[styles.flexDesktopGapVar] = gapProp.desktopAndAbove != null ? getSpacing(gapProp.desktopAndAbove) : undefined;
      vars[styles.flexXLargeGapVar] = gapProp.xLargeAndAbove != null ? getSpacing(gapProp.xLargeAndAbove) : undefined;
      vars[styles.flexXXLargeGapVar] = gapProp.xxLargeDesktop != null ? getSpacing(gapProp.xxLargeDesktop) : undefined;
      gap = {
        mobileAndAbove: styles.flexGapVar,
        tabletAndAbove: gapProp.tabletAndAbove != null ? styles.flexTabletGapVar : undefined,
        desktopAndAbove: gapProp.desktopAndAbove != null ? styles.flexDesktopGapVar : undefined,
        xLargeAndAbove: gapProp.xLargeAndAbove != null ? styles.flexXLargeGapVar : undefined,
        xxLargeDesktop: gapProp.xxLargeDesktop != null ? styles.flexXXLargeGapVar : undefined
      };
    } else {
      gap = styles.flexGapVar;
      vars[styles.flexGapVar] = getSpacing(gapProp);
    }
  }
  var flex = undefined;
  var flexGrow = undefined;
  var flexShrink = undefined;
  var flexBasis = undefined;
  if (flexProp && typeof flexProp === "string" && /^\d/.test(flexProp)) {
    var _parts$, _parts$2;
    var parts = flexProp.split(" ");
    vars[styles.flexGrowVar] = parts[0];
    vars[styles.flexShrinkVar] = (_parts$ = parts[1]) !== null && _parts$ !== void 0 ? _parts$ : "1";
    vars[styles.flexBasisVar] = (_parts$2 = parts[2]) !== null && _parts$2 !== void 0 ? _parts$2 : "0%";
    flexGrow = styles.flexGrowVar;
    flexShrink = styles.flexShrinkVar;
    flexBasis = styles.flexBasisVar;
  } else {
    flex = flexProp;
  }
  return /*#__PURE__*/React.createElement(asProp || "div", _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    style: _objectSpread(_objectSpread({}, assignInlineVars(vars)), styleProp),
    className: cn(classNameProp, styles.displayFlex, styles.sprinkles({
      gap: gap,
      flex: flex,
      flexGrow: flexGrow,
      flexShrink: flexShrink,
      flexBasis: flexBasis,
      alignItems: alignProp,
      flexDirection: directionProp,
      justifyContent: justifyProp
    }))
  }), children);
});